(function () {
  function initPoliciesSection(section) {
    const tabButtons = section.querySelectorAll('.policies-section__sidebar [data-policies-tab]');
    const dropdownItems = section.querySelectorAll('[data-policies-dropdown-item]');
    const panels = section.querySelectorAll('[data-policies-panel]');
    const dropdown = section.querySelector('[data-policies-dropdown]');
    const dropdownTrigger = section.querySelector('[data-policies-dropdown-trigger]');
    const dropdownLabel = section.querySelector('[data-policies-dropdown-label]');

    const activeTitleEl = section.querySelector('[data-policies-active-title]');
    const activeUpdatedEl = section.querySelector('[data-policies-active-updated]');

    if (!tabButtons.length || !panels.length) return;

    function activateTab(slug) {
      tabButtons.forEach((btn) => btn.classList.remove('policies-section__tab--active'));
      dropdownItems.forEach((item) => item.classList.remove('policies-section__dropdown-item--active'));
      panels.forEach((panel) => panel.classList.remove('policies-section__panel--active'));

      const activeBtn = Array.from(tabButtons).find(
        (btn) => btn.dataset.policiesTab.toLowerCase() === slug.toLowerCase()
      );
      const activeDropdownItem = Array.from(dropdownItems).find(
        (item) => item.dataset.policiesTab.toLowerCase() === slug.toLowerCase()
      );
      const activePanel = Array.from(panels).find(
        (panel) => panel.dataset.policiesPanel.toLowerCase() === slug.toLowerCase()
      );

      if (activeBtn) activeBtn.classList.add('policies-section__tab--active');
      if (activeDropdownItem) activeDropdownItem.classList.add('policies-section__dropdown-item--active');
      if (activePanel) activePanel.classList.add('policies-section__panel--active');

      // Update shared active header above the panels
      if (activePanel) {
        const title = activePanel.dataset.panelTitle || '';
        const updated = activePanel.dataset.panelUpdated || '';
        if (activeTitleEl) activeTitleEl.textContent = title;
        if (activeUpdatedEl) {
          if (updated) {
            activeUpdatedEl.textContent = 'Last updated: ' + updated;
            activeUpdatedEl.style.display = '';
          } else {
            activeUpdatedEl.textContent = '';
            activeUpdatedEl.style.display = 'none';
          }
        }
      }

      // Sync mobile dropdown label to the active tab label text
      if (dropdownLabel && activeBtn) {
        const labelText = activeBtn.querySelector('[data-tab-label]');
        dropdownLabel.textContent = labelText
          ? labelText.textContent.trim()
          : activeBtn.childNodes[0]?.textContent?.trim() || '';
      }
    }

    // Desktop sidebar tab clicks
    tabButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const slug = btn.dataset.policiesTab;
        activateTab(slug);
        history.replaceState(null, null, `${window.location.pathname}?${slug}`);
      });
    });

    // Mobile dropdown item clicks
    dropdownItems.forEach((item) => {
      item.addEventListener('click', () => {
        const slug = item.dataset.policiesTab;
        activateTab(slug);
        closeDropdown();
        history.replaceState(null, null, `${window.location.pathname}?${slug}`);
      });
    });

    // Mobile dropdown open/close
    function openDropdown() {
      if (dropdown) dropdown.classList.add('policies-section__dropdown--open');
    }

    function closeDropdown() {
      if (dropdown) dropdown.classList.remove('policies-section__dropdown--open');
    }

    if (dropdownTrigger) {
      dropdownTrigger.addEventListener('click', (e) => {
        e.stopPropagation();
        if (dropdown && dropdown.classList.contains('policies-section__dropdown--open')) {
          closeDropdown();
        } else {
          openDropdown();
        }
      });
    }

    // Close dropdown on outside click
    document.addEventListener('click', (e) => {
      if (dropdown && !dropdown.contains(e.target)) {
        closeDropdown();
      }
    });

    // Activate initial tab — use URL slug if it matches a known tab, otherwise fall back to first tab
    const querySlug = window.location.search.substring(1);
    const firstSlug = tabButtons[0]?.dataset.policiesTab || '';
    const slugExists = querySlug && Array.from(panels).some(
      (panel) => panel.dataset.policiesPanel.toLowerCase() === querySlug.toLowerCase()
    );
    const initialSlug = slugExists ? querySlug : firstSlug;
    if (initialSlug) activateTab(initialSlug);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-policies-section]').forEach(initPoliciesSection);
  });
})();
